import { Col, Row, Select } from 'antd';
import { FC, useMemo } from 'react';
import styles from './index.less';
import { getCertList } from '@/services/ConsoleRequest';
import { useRequest } from 'umi';
import { map } from 'lodash';

export type TCerObj = {
  certId: string;
  name: string;
};

const CertificationCom: FC<{ defaultValue?: string; onChange?: (certId: string) => void }> = ({
  defaultValue,
  onChange,
}) => {
  const { data } = useRequest(() => {
    return getCertList();
  });
  const options = useMemo(() => {
    return map(data, (item) => ({
      value: item.certId,
      label: item.name,
    }));
  }, [data]);

  return (
    <div className={styles.cert_com}>
      <Row className="ant-form-item">
        <Col span={4} className="ant-form-item-label">
          <label className="ant-form-item-required" title="批阅人uid">
            需通过认证
          </label>
        </Col>
        <Col span={16}>
          <Select defaultValue={defaultValue} options={options} onChange={onChange} />
        </Col>
      </Row>
    </div>
  );
};
export default CertificationCom;
